module.exports = [
    "CR",
    "DX",
    "CT",
    "MR",
    "XA",
    "MG",
    "US",
    "PT",
    "NM",
    "RF",
    "RG",
    "PX",
    "ES",
    "XC",
    "GM",
    "SC",
    "OT",
    "SR"
];
